let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("ejM5d")]).then(() => parcelRequire('3nYjj'));